var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJira(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_537_142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.1645 0H30.4268C30.4268 3.68001 31.8886 7.2093 34.4908 9.81146C37.093 12.4136 40.6222 13.8755 44.3023 13.8755H49.9645V19.3425C49.9695 26.9988 56.1748 33.2043 63.831 33.2093V2.6665C63.831 1.19425 62.6375 0 61.1645 0Z",
    fill: "#2684FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9553 15.3154H15.2178C15.2225 22.9717 21.4278 29.1772 29.0843 29.1822H34.7465V34.6667C34.7563 42.3229 40.9658 48.5242 48.622 48.5242V17.9824C48.622 16.5097 47.428 15.3154 45.9553 15.3154Z",
    fill: "url(#paint0_linear_537_142)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7377 30.6223H0C0 38.2856 6.2125 44.4978 13.8755 44.4978H19.5555V49.9646C19.5605 57.6138 25.755 63.8166 33.4045 63.8311V33.2891C33.4045 31.8163 32.2105 30.6223 30.7377 30.6223Z",
    fill: "url(#paint1_linear_537_142)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_537_142",
    x1: 3289.87,
    y1: 20.6621,
    x2: 1990.28,
    y2: 1376.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_537_142",
    x1: 3362.66,
    y1: 45.7323,
    x2: 1859.37,
    y2: 1524.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_537_142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJira);
export default __webpack_public_path__ + "static/media/Jira.bec96b4a45cf206bbb3eefc90b2aa59d.svg";
export { ForwardRef as ReactComponent };